(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NLT-whatsappwidget"] && !Shopify.designMode) return;
  try {
    
  (() => {
      if (!window.customElements || window.customElements.get('nlt-whatsapp-widget')) return;

      class NltWhatsAppWidget extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.launcher = this.querySelector('[data-nlt-launcher]');
          this.closeButton = this.querySelector('[data-nlt-close]');
          this.panel = this.querySelector('[data-nlt-panel]');

          if (!this.launcher || !this.closeButton || !this.panel) return;

          this.dataset.initialized = 'true';

          this.handleLauncherClick = () => {
            const shouldOpen = !this.classList.contains('is-open');
            this.setOpen(shouldOpen);

            if (shouldOpen) {
              this.closeButton.focus({ preventScroll: true });
            }
          };

          this.handleCloseClick = () => {
            this.setOpen(false);
            this.launcher.focus({ preventScroll: true });
          };

          this.handleKeydown = (event) => {
            if (event.key === 'Escape' && this.classList.contains('is-open')) {
              this.setOpen(false);
              this.launcher.focus({ preventScroll: true });
            }
          };

          this.handleDocumentClick = (event) => {
            if (!this.contains(event.target) && this.classList.contains('is-open')) {
              this.setOpen(false);
            }
          };

          this.launcher.addEventListener('click', this.handleLauncherClick);
          this.closeButton.addEventListener('click', this.handleCloseClick);
          document.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('click', this.handleDocumentClick);

          const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
          if (this.dataset.openDefault === 'true' && !isThemeEditor) {
            this.openTimer = window.setTimeout(() => this.setOpen(true), 650);
          }
        }

        disconnectedCallback() {
          if (this.openTimer) {
            window.clearTimeout(this.openTimer);
          }

          if (this.launcher && this.handleLauncherClick) {
            this.launcher.removeEventListener('click', this.handleLauncherClick);
          }

          if (this.closeButton && this.handleCloseClick) {
            this.closeButton.removeEventListener('click', this.handleCloseClick);
          }

          if (this.handleKeydown) {
            document.removeEventListener('keydown', this.handleKeydown);
          }

          if (this.handleDocumentClick) {
            document.removeEventListener('click', this.handleDocumentClick);
          }

          this.removeAttribute('data-initialized');
          this.launcher = null;
          this.closeButton = null;
          this.panel = null;
        }

        setOpen(open) {
          if (!this.launcher || !this.panel) return;

          this.classList.toggle('is-open', open);
          this.launcher.setAttribute('aria-expanded', String(open));
          this.panel.setAttribute('aria-hidden', String(!open));
        }
      }

      window.customElements.define('nlt-whatsapp-widget', NltWhatsAppWidget);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
